import ApiMethods from "../../ApiManager/ApiMethods";
import {
  upsertClientPackageInCache,
  refreshMembers,
} from "../../app/data/membersStore";

// Single source of truth for "POST client-packages/create, then reflect the result in the
// shared membersStore cache" — used by PackageAssignFlow.jsx's confirm-step assign (one call
// per member, for multi-vežbač packages). No more start_date — a cycle's start is now derived
// server-side from its own first booking (see view_clients_packages_full). `price` is only sent
// for the "Dodeli i plati" (pay now) path, where the admin confirms/edits it in a popup;
// "Dodeli i plati kasnije" omits both price and paymentDate and lets the package's own price
// apply, unpaid, until it's paid later.
export async function createClientPackage({
  clientId,
  packageId,
  price,
  paymentDate,
  notes,
}) {
  const response = await ApiMethods.post("client-packages/create", {
    client_id: clientId,
    package_id: packageId,
    price: price ?? undefined,
    payment_date: paymentDate || undefined,
    notes: notes || undefined,
    created_by: localStorage.getItem("id"),
  });
  if (response?.clientPackage) {
    upsertClientPackageInCache(clientId, response.clientPackage);
  } else {
    // No row came back on the response (shouldn't normally happen — the save itself already
    // succeeded, no exception was thrown) — fall back to a background refresh rather than
    // leaving the cache stale until a manual reload.
    refreshMembers();
  }
  return response?.clientPackage;
}
